import { logger } from '../logger-client.js'

type UrlAnalysisApiResponse = {
  success?: boolean
  urlContext?: unknown
  analysis?: unknown
  output?: { analysis?: unknown }
  error?: unknown
}

function readUrlContext(body: UrlAnalysisApiResponse): string {
  if (typeof body.urlContext === 'string') return body.urlContext
  if (typeof body.analysis === 'string') return body.analysis
  if (typeof body.output?.analysis === 'string') return body.output.analysis
  return ''
}

export async function detectAndAnalyzeUrlsFromServer(
  messageContent: string
): Promise<string> {
  if (typeof messageContent !== 'string' || messageContent.trim().length === 0) {
    return ''
  }

  try {
    const response = await fetch('/api/tools?tool=url-analysis', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messageContent }),
    })

    if (!response.ok) {
      logger.warn('[url-analysis-client] URL analysis request failed', {
        status: response.status,
      })
      return ''
    }

    const body = (await response.json().catch(() => null)) as UrlAnalysisApiResponse | null
    if (!body || typeof body !== 'object') return ''

    return readUrlContext(body)
  } catch (error) {
    logger.warn('[url-analysis-client] URL analysis unavailable', {
      error: error instanceof Error ? error.message : String(error),
    })
    return ''
  }
}
